import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { variant1, variant2 } from './constants';
import InventoryTrimPayment from './InventoryTrimPayment';
import BapTrimPayment from './BAPTrimPayment';
const TrimPayment = ({ rendering, fields, params }) => {
    var _a, _b, _c;
    const mode = params === null || params === void 0 ? void 0 : params.variant;
    const title = ((_c = (_b = (_a = fields === null || fields === void 0 ? void 0 : fields.data) === null || _a === void 0 ? void 0 : _a.value) === null || _b === void 0 ? void 0 : _b.title) === null || _c === void 0 ? void 0 : _c.value) || '';
    const componentName = (rendering === null || rendering === void 0 ? void 0 : rendering.componentName) || '';
    switch (mode) {
        case variant1:
            return _jsx(BapTrimPayment, {});
        case variant2:
            return _jsx(InventoryTrimPayment, { title: title, componentName: componentName });
        default:
            return _jsx(BapTrimPayment, {});
    }
};
export default TrimPayment;
